import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import {
  GlobalAlertService,
  ListOcctoCredentialAlertsRequestSchema,
} from '@ebalance/proto/bffuser/v1/global_alert_service_pb'

/** 警告の再取得間隔 (60 秒)。提出済になってから数十秒で消えれば運用上足りる (Design Note Decision 7)。 */
const OCCTO_CREDENTIAL_ALERTS_REFETCH_INTERVAL_MS = 60 * 1000

/**
 * OCCTO 認証情報の不備で計画を提出できない事業者コードの一覧 (AC-PLC-053)。
 * 全画面共通の TickerBar が使う補助情報。
 *
 * - request は空 (organization は BFF が eauth から解決する)
 * - `throwOnError: false` 必須: 補助情報 1 本の失敗で全画面をエラーにしない
 *   (`useCurrentSession` と同じ。本番 QueryClient の既定は throwOnError: true)
 * - 取得失敗 (isError) 中は、直前の成功値を保持していても空扱いにする。
 *   古い警告を出し続けるより出さない側に倒す (AC-SC-034 注記と同じ扱い)
 *
 * 返す事業者コードは昇順に並べ直す (backend も昇順だが、表示順を表示側で保証する)。
 */
export function useOcctoCredentialAlerts(): { businessCodes: string[] } {
  const { data, isError } = useQuery(
    GlobalAlertService.method.listOcctoCredentialAlerts,
    create(ListOcctoCredentialAlertsRequestSchema, {}),
    {
      refetchInterval: OCCTO_CREDENTIAL_ALERTS_REFETCH_INTERVAL_MS,
      refetchOnWindowFocus: true,
      retry: false,
      staleTime: 0,
      throwOnError: false,
    },
  )
  if (isError || data === undefined) {
    return { businessCodes: [] }
  }
  return {
    businessCodes: data.alerts.map((a) => a.businessCode).sort(),
  }
}
